import AuthenticatedUserContext from "@/contexts/authentication/AuthenticatedUserContext";
import InstitutionContext from "@/contexts/data/InstitutionContext";
import InstitutionsContext from "@/contexts/data/InstitutionsContext";
import { generateSlug } from "@/utils";
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";
import { Button, Divider, Menu, MenuItem, styled } from "@mui/material";
import { FC, MouseEvent, useContext, useMemo, useState } from "react";
import { Link as RouteLink } from 'react-router-dom';
import Icon from "./Icon/Icon";

const StyledDivider = styled(Divider)(() => ({
    margin: `0 !important`
}));

const StyledButton = styled(Button)(({ theme }) => ({
    marginRight: theme.spacing(2),
    fontWeight: 500,
    fontFamily: "Roboto",
    fontSize: '0.95rem',
    color: 'inherit',
    transition: 'none'
}));

const NavigationInstitutionSelector: FC = () => {    

    const { data: institution } = useContext(InstitutionContext);
    const { data: institutions } = useContext(InstitutionsContext);
    const { isAdmin, isBctStaff, isMedicalReviewer, isCentralScientist } = useContext(AuthenticatedUserContext)
    
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleMenu = (event: MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const list = useMemo(() => {        
        return institutions?.map((x, i, a) => {
            return (
                [
                    <MenuItem key={x.id} component={RouteLink} to={`/${x.id}/${generateSlug(x.name ?? 'unknown')}`} onClick={handleClose}>{x.name}</MenuItem>,
                    i < (a.length - 1) ? <StyledDivider key={`${x.code}-divider`} /> : null
                ]
            );
        })
    }, [institutions, handleClose])

    if (!institutions || institutions.length === 0) {
        return null;
    }

    const showAllInstitutions = (isAdmin || isBctStaff || isMedicalReviewer || isCentralScientist);
    
    return (
        <>
            <StyledButton
                id="btn-institutions"
                aria-label="institution selection"
                aria-controls="menu-institutions"
                aria-haspopup="true"
                onClick={handleMenu}
                endIcon={<Icon icon={faChevronDown} style={{fontSize: '1rem'}} fixedWidth />}
            >
                {
                    institution ?
                        institution.name :
                        'All Institutions'
                }
            </StyledButton>
            <Menu
                id="menu-institutions"
                anchorEl={anchorEl}
                keepMounted
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={anchorEl?.id === 'btn-institutions'}
                onClose={handleClose}
                MenuListProps={{
                    disablePadding: true
                }}
            >
                {
                    showAllInstitutions && (
                        <MenuItem component={RouteLink} to={'/all-institutions'} onClick={handleClose}>All Institutions</MenuItem>
                    )
                }
                {
                    showAllInstitutions && (
                        <StyledDivider />
                    )
                }
                {list}
            </Menu>
        </>
    )
}

export default NavigationInstitutionSelector;